import { AppState } from '../../model';

const reducer = (state, payload) => {
  switch (payload.type) {
    case 'UPDATE_STATE': {
      return new AppState(
        state.user,
        state.boards,
        state.pusher,
        state.dispatch,
      );
    }
    case 'LOGIN_REQUEST': {
      if (payload.user) {
        state.user.login(payload.user);
      }
      return state;
    }
    case 'LOGOUT_REQUEST': {
      state.logout();
      return state;
    }
    case 'SET_ERROR': return state;
    default:
      return state;
  }
};

export default reducer;
